var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-account"},[_c('indexHeader'),_c('div',{staticClass:"account"},[_c('left',{attrs:{"lang":_vm.lang,"current":0}}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }